import { LogoLoading } from "./LogoLoading";

// In-app full-area wait (e.g. the project homepage while its context loads).
// Identical to the boot splash so the layered loaders read as one continuous
// moment — captions are intentionally omitted.
export const WorkspaceLoading = () => {
  return <LogoLoading />;
};
